import getAppSite from 'utils/getAppSite';

const returnCorrectWPUrl = () => {
  let url = `https://`;
  switch (import.meta.env.VITE_APP_APPURL) {
    case 'https://policymogul.com':
      url += 'about.policymogul.com';
      break;
    case 'https://us.policymogul.com':
      url += 'us-about.policymogul.com';
      break;
    case 'https://us-staging.policymogul.com':
      url += 'us-staging-about.policymogul.com';
      break;
    default:
      url += getAppSite() === 'usa' ? 'us-staging-about.policymogul.com' : 'staging-about.policymogul.com';
  }
  return url;
};

export default returnCorrectWPUrl;
